import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";

import Loading from "../../../components/UI/Loading";
import { getTokenInfo } from "../../../utils/Guard";

import {
  Activedocumenttype,
  Getdocumenttype,
  Inactivedocumenttype,
} from "../../../store/documenttype-store/documenttype-actions";

const DocumenttypeDetail = () => {
  const param = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const documenttype = useSelector((state) => state.documenttype.documenttype);
  const notification = useSelector((state) => state.ui.notification);
  const userInfo = getTokenInfo();

  const documenttypeData = [
    { label: "Nombre", value: documenttype.name },
    { label: "Descripción", value: documenttype.description },
    { label: "Código", value: documenttype.code },
  ];

  useEffect(() => {
    if (documenttype.id === undefined || documenttype.id === 0) {
      dispatch(Getdocumenttype(param.documenttypeId, userInfo.Email));
    }
  }, [param.documenttypeId, dispatch, documenttype.id, userInfo.Email]);

  const activeHandler = () => {
    dispatch(Activedocumenttype(param.documenttypeId, userInfo.Email));
  };
  const inactiveHandler = () => {
    dispatch(Inactivedocumenttype(param.documenttypeId, userInfo.Email));
  };
  let activeSuspend;
  if (
    userInfo.Roles !== undefined &&
    userInfo.Roles.includes("documentType.Active")
  ) {
    activeSuspend = (
      <div className="field col-12 md:col-3 ">
        <Button
          rounded
          text
          raised
          style={{ backgroundColor: "#fff", width: "150px" }}
          label="Activar"
          className="p-button-success"
          onClick={activeHandler}
          icon={
            notification && notification.status === "pending"
              ? "pi pi-spin pi-spinner"
              : "pi pi-check"
          }
          disabled={notification && notification.status === "pending"}
        />
      </div>
    );
  }
  if (documenttype.status) {
    if (
      userInfo.Roles !== undefined &&
      userInfo.Roles.includes("documentType.Inactive")
    ) {
      activeSuspend = (
        <div className="field col-12 md:col-3">
          <Button
            rounded
            text
            raised
            style={{ backgroundColor: "#fff", width: "150px" }}
            label="Suspender"
            className="p-button-warning"
            onClick={inactiveHandler}
            icon={
              notification && notification.status === "pending"
                ? "pi pi-spin pi-spinner"
                : "pi pi-times"
            }
            disabled={notification && notification.status === "pending"}
          />
        </div>
      );
    }
  }

  return (
    <>
      <div
        style={{ backgroundColor: "#133047", padding: "1%", height: "100vh" }}
      >
        {(documenttype.id === undefined || documenttype.id <= 0) && (
          <>
            <Loading />
          </>
        )}
        {(documenttype.id !== undefined || documenttype.id > 0) && (
          <Card
            style={{
              backgroundColor: "#F9FAFB",
              marginLeft: "0%",
              boxShadow: "none",
              width: "100%",
              height: "auto",
            }}
          >
            <div
              className="user-info text-center"
              style={{
                borderBottom: "solid #fff",
                fontWeight: "bold",
                paddingBottom: "1.3%",
              }}
            >
              <h2 id="header" className="mb-2" style={{ color: "" }}>
                {documenttype.name}
              </h2>
              <span
                className="badge bg-label-secondary"
                style={{
                  fontSize: "large",
                  color: "#D34330",
                  fontWeight: "bold",
                }}
              >
                Tipo de documento
              </span>
            </div>
            <div className="formgrid grid mt-3">
              <div className="field col-12 md:col-12 mt-3">
                <DataTable
                  value={documenttypeData}
                  style={{ width: "100%", padding: "1%" }}
                >
                  <Column
                    field="label"
                    style={{
                      width: "50%",
                      textAlign: "right",
                      fontWeight: "bold",
                    }}
                    bodyStyle={{ textAlign: "left" }}
                  />
                  <Column
                    field="value"
                    style={{ width: "50%", textAlign: "left" }}
                    bodyStyle={{ textAlign: "left" }}
                  />
                </DataTable>
              </div>
              <div className="field col-12 md:col-3">
                <Button
                  rounded
                  text
                  raised
                  style={{ backgroundColor: "#fff", width: "150px" }}
                  label="Regresar"
                  icon="pi pi-arrow-left"
                  className="p-button-danger"
                  onClick={() => {
                    navigate("/documenttype");
                  }}
                />
              </div>
              {userInfo.Roles !== undefined &&
                userInfo.Roles.includes("documentType.edit") && (
                  <div className="field col-12 md:col-3">
                    <Button
                      rounded
                      text
                      raised
                      style={{ backgroundColor: "#fff", width: "150px" }}
                      label="Editar"
                      icon="pi pi-file-edit"
                      className="p-button-primary"
                      onClick={() => {
                        navigate(`/documenttype/edit/${documenttype.id}`);
                      }}
                    />
                  </div>
                )}
              {activeSuspend}
            </div>
          </Card>
        )}
      </div>
    </>
  );
};
export default DocumenttypeDetail;
